import { Chess } from 'chess.js';
export class ChessLogic {
    constructor(fen) {
        this.game = new Chess(fen);
    }
    get fen() {
        return this.game.fen();
    }
    get turn() {
        return this.game.turn();
    }
    get isGameOver() {
        return this.game.isGameOver();
    }
    get isCheckmate() {
        return this.game.isCheckmate();
    }
    get isDraw() {
        return this.game.isDraw();
    }
    get isCheck() {
        return this.game.isCheck();
    }
    get history() {
        return this.game.history();
    }
    makeMove(move) {
        try {
            const result = this.game.move(move);
            return !!result;
        }
        catch (e) {
            return false;
        }
    }
    getLegalMoves() {
        return this.game.moves();
    }
    getVerboseMoves() {
        return this.game.moves({ verbose: true }).map(m => ({
            from: m.from,
            to: m.to,
            promotion: m.promotion
        }));
    }
    getState() {
        return {
            fen: this.game.fen(),
            turn: this.game.turn(),
            isCheck: this.game.isCheck(),
            isCheckmate: this.game.isCheckmate(),
            isDraw: this.game.isDraw(),
            winner: this.game.isCheckmate() ? (this.game.turn() === 'w' ? 'b' : 'w') : undefined
        };
    }
    reset() {
        this.game.reset();
    }
    load(fen) {
        this.game.load(fen);
    }
}
